import {
  GET_EXPENSE_DASHBOARD_FAILURE,
  GET_EXPENSE_DASHBOARD_REQUEST,
  GET_EXPENSE_DASHBOARD_SUCCESS,
} from './expenseManagerDashboard.types';
import produce from 'immer';

const initialState = {
  followUpExpenses: [],
  followUpVouchers: [],
  recurringPayables: [],
  coveragePeriods: [],
  exceptionComments: [],
  expenseAnalystSummaries: [],
  isLoading: false,
  error: null,
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    default:
      break;

    // Get Expense Dashboard (aggregate of all table collections)
    case GET_EXPENSE_DASHBOARD_REQUEST:
      draft.isLoading = true;
      draft.error = null;
      break;

    case GET_EXPENSE_DASHBOARD_SUCCESS:
      draft.followUpExpenses = action.response?.followUpExpenses || [];
      draft.followUpVouchers = action.response?.followUpVouchers || [];
      draft.recurringPayables = action.response?.recurringPayables || [];
      draft.coveragePeriods = action.response?.coveragePeriods || [];
      draft.exceptionComments = action.response?.exceptionComments || [];
      draft.expenseAnalystSummaries = action.response?.expenseAnalystSummaries || [];
      draft.isLoading = false;
      break;

    case GET_EXPENSE_DASHBOARD_FAILURE:
      draft.isLoading = false;
      draft.error = action.messages || ['Failed to load expense dashboard'];
      break;
  }
  return draft;
}, initialState);
